// Models
import Model from './Model'
import AccountNumber from './AccountNumber'
import AccountBalance from './AccountBalance'
import AccountCard from './AccountCard'

// Data
import currencies from '@/assets/data/currencies'
import cryptoCurrencies from '@/assets/data/crypto-currencies'

class Account extends Model {
  get isUsedAsMaster () {
    return this.type === 'CUSTOMER'
  }

  get isUsedForFee () {
    return this.useForFee === true
  }

  get isUsedForMasterFee () {
    return this.masterWalletIds.length > 0
  }

  get isVaultAccount () {
    return this.isVaultActive !== null
  }

  get isRecurringFeeFree () {
    return this.recurringFeeFree === true
  }

  get isBlocked () {
    return this.block != null
  }

  get isBlockedByAdmin () {
    if (this.isBlocked) {
      return this.block.admin != null
    }

    return false
  }

  get hasName () {
    return this.name != null && this.name !== ''
  }

  get hasOnlyOneCurrency () {
    return this.currencyOptions.length === 1
  }

  get currencyOptions () {
    return this.balances.map(balance => ({
      name: balance.currency,
      value: balance.currency
    }))
  }

  // TODO: rename to allowedCurrencyOptions
  static get currencyOptions () {
    return currencies.map(currency => ({
      name: currency,
      value: currency
    }))
  }

  static get cryptoCurrencyOptions () {
    return cryptoCurrencies.map(currency => ({
      name: currency,
      value: currency
    }))
  }

  static get allCurrencyOptions () {
    return [...Account.currencyOptions, ...Account.cryptoCurrencyOptions]
  }

  get formatters () {
    return {
      accountNumbers: dataArray => dataArray.map(data => new AccountNumber(data)),
      balances: dataArray => dataArray.map(data => new AccountBalance(data)),
      cards: dataArray => dataArray.map(data => new AccountCard(data))
    }
  }

  get schema () {
    return [
      'accountId',
      'name',
      'type',
      'active',
      'blockedByAdministrator',
      'allowedRequisites',
      'allowedIncomingChannels',
      'allowedOutgoingChannels',
      'accountNumbers',
      'balances',
      'block',
      'useForFee',
      'masterWalletIds',
      'isVaultActive',
      'recurringFeeFree',
      'cards',
      'createdAt',
      'integratorType',
      'profileCustomerWallet',
      'feeWalletId'
    ]
  }
}

export default Account
